import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { label, white } from '../../../../styles/colors';

const { spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	contentSection: {
		padding: '12px 20px',
	},
	contentHeader: {
		display: 'flex',
		gap: spacing.sm,
	},
	serviceJobIcon: {
		fill: white,
	},
	contentListTitle: {
		marginTop: spacing.sm,
		marginBottom: spacing.lg,
	},
	contentAddButton: {
		marginBottom: 10,
		marginLeft: 'auto',
	},
	tableOverrides: {
		marginTop: spacing.md,
		padding: spacing.sm,
	},
	emptyText: {
		// label (#4A4A4A) has no exact THEME token; retained to avoid shifting the text color.
		color: label,
		fontSize: typography.fontSizes.sm,
	},
	jobNumber: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
	},
});
